import { useEffect, useState } from "react";

function useHeaderHeight() {
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const headerElement = document.querySelector("header");

    if (!headerElement) return;

    // Update the height initially
    setHeaderHeight(headerElement.offsetHeight);

    // Create a ResizeObserver to handle dynamic resizing
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === headerElement) {
          setHeaderHeight(entry.contentRect.height);
        }
      }
    });

    observer.observe(headerElement);

    return () => {
      observer.unobserve(headerElement);
    };
  }, []);

  return headerHeight;
}
export default useHeaderHeight;
